import { useMessages } from "../../i18n/provider";
import styles from "./auth.module.css";
import { AuthFooterLink, AuthLayout } from "./layout";

export function VerifyEmailPage() {
  const t = useMessages();
  return (
    <AuthLayout
      title={t("auth.verifyTitle")}
      footer={<AuthFooterLink to="/login" label={t("auth.backToSignIn")} />}
    >
      <div className={styles.sent} role="status">
        {t("auth.verifyBody")}
      </div>
    </AuthLayout>
  );
}
